import React from 'react';

import { Box, Stack, Text, Title, UnstyledButton } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { useGLMCardStyles } from '../styles';
import {
  GLMKiloFlowTriggers,
  GLMKiloFormValues,
  TRIGGER_DESCRIPTIONS,
  TRIGGER_GROUPS,
  TRIGGER_LABELS,
} from '../types';

interface IGLMKiloTriggerSelectProps {
  form: UseFormReturnType<GLMKiloFormValues, (values: GLMKiloFormValues) => GLMKiloFormValues>;
  onSelect: (trigger: GLMKiloFlowTriggers) => void;
  locked?: boolean;
}

const GLMKiloTriggerSelect = ({
  form,
  onSelect,
  locked = false,
}: IGLMKiloTriggerSelectProps): JSX.Element => {
  const { classes, cx } = useGLMCardStyles();

  return (
    <Stack sx={{ paddingTop: '20px' }}>
      <Title order={3}>What happens in GLM?</Title>
      <Text size={15}>Pick the Gym Lead Machine event that should drive an action in Kilo.</Text>
      {locked && (
        <Text size='sm' color='dimmed'>
          The trigger can&apos;t be changed after the flow is created.
        </Text>
      )}
      <Stack spacing='md'>
        {TRIGGER_GROUPS.map(group => (
          <Stack key={group.label} spacing={6}>
            <Text size='xs' weight={600} color='dimmed' className={classes.groupLabel}>
              {group.label}
            </Text>
            <Stack spacing={6}>
              {group.triggers.map(trigger => {
                const isSelected = form.values.trigger === trigger;
                return (
                  <UnstyledButton
                    key={trigger}
                    disabled={locked}
                    onClick={() => !locked && onSelect(trigger)}
                  >
                    <Box
                      className={cx(classes.card, {
                        [classes.cardSelected]: isSelected,
                        [classes.cardDisabled]: locked && !isSelected,
                      })}
                    >
                      <Text weight={isSelected ? 600 : 400}>{TRIGGER_LABELS[trigger]}</Text>
                      {isSelected && (
                        <Text size='sm' color='#6B6B6B' mt={4}>
                          {TRIGGER_DESCRIPTIONS[trigger]}
                        </Text>
                      )}
                    </Box>
                  </UnstyledButton>
                );
              })}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default GLMKiloTriggerSelect;
